import React from 'react';
import { Link } from 'react-router-dom';
import LoginForm from '../../components/LoginForm'; // Adjust path
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "../../components/ui/card"; // Adjust path

const LoginPage: React.FC = () => {
  return (
    <div className="min-h-[calc(100vh-var(--navbar-height,64px)-var(--footer-height,41px))] flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
      {/* Use Card component for structure */}
      <Card className="max-w-md w-full">
        <CardHeader className="space-y-1 text-center">
          <CardTitle className="text-2xl font-bold">Sign In</CardTitle>
          <CardDescription>
            Enter your email below to login to your account
          </CardDescription>
          <p className="!pt-2 text-sm text-muted-foreground">
             Or{" "}
             <Link to="/register" className="font-medium text-primary underline-offset-4 hover:underline">
               register for a new account
             </Link>
          </p>
        </CardHeader>
        <CardContent>
          <LoginForm />
        </CardContent>
      </Card>
    </div>
  );
};

export default LoginPage; 